<div
  *ngIf="showTerminosyCondiciones"
  id="terminosCondicionesModal"
  class="modal fixed inset-0 bg-black bg-opacity-70 flex items-start justify-center z-50 overflow-y-auto"
  (click)="closeModal()"
>
  <div
    class="relative rounded-lg max-w-2xl w-full text_white overflow-hidden shadow-lg mx-4 sm:mx-8 my-10 max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón de cierre -->
    <button
      class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="closeModal()"
    >
      &times;
    </button>

    <!-- Contenido de la modal -->
    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-start card_color rounded-lg text_gray"
    >
      <div class="mb-4">
        <h2 class="text-2xl sm:text-3xl font-bold mb-4 text-center text_white">
          Términos y Condiciones
        </h2>
      </div>
      <div
        class="overflow-y-auto max-h-96 text-sm sm:text-md leading-relaxed text_white"
      >
        <p class="mb-4">
          Bienvenido a nuestra plataforma. Al utilizar nuestros servicios, usted
          acepta cumplir con los términos y condiciones establecidos en este
          documento. Nos reservamos el derecho de actualizar o modificar estos
          términos en cualquier momento, y se recomienda revisarlos
          regularmente.
        </p>
        <p class="mb-4">
          El contenido de este sitio web, incluidos textos, imágenes y gráficos,
          está protegido por derechos de autor. No está permitido reproducir,
          distribuir o modificar este contenido sin nuestra autorización previa
          por escrito.
        </p>
        <p class="mb-4">
          Al registrarse, usted acepta proporcionar información verdadera y
          precisa. Nos reservamos el derecho de suspender o eliminar cuentas en
          caso de incumplimiento.
        </p>
        <p class="mb-4">
          Si tiene alguna pregunta, no dude en ponerse en contacto con nuestro
          equipo de soporte.
        </p>
      </div>

      <!-- Botón para aceptar términos -->
      <button
        type="button"
        class="close-modal mt-6 py-3 px-6 text-base font-medium text_white template_color_customize rounded-lg hover:opacity-70 transition"
        (click)="closeModal()"
      >
        Aceptar
      </button>
    </div>
  </div>
</div>

<div
  *ngIf="showPrivacyPolicy"
  id="politicaPrivacidadModal"
  class="modal fixed inset-0 bg-black bg-opacity-70 flex items-start justify-center z-50 overflow-y-auto"
  (click)="closeModal()"
>
  <div
    class="relative rounded-lg max-w-2xl w-full text_white overflow-hidden shadow-lg mx-4 sm:mx-8 my-10 max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón de cierre -->
    <button
      class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="closeModal()"
    >
      &times;
    </button>

    <!-- Contenido de la modal -->
    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-start card_color rounded-lg text_white"
    >
      <div class="mb-4">
        <h2 class="text-2xl sm:text-3xl font-bold mb-4 text-center text_white">
          Política de Privacidad
        </h2>
      </div>
      <div
        class="overflow-y-auto max-h-96 text-sm sm:text-md leading-relaxed text_white"
      >
        <p class="mb-4">
          En nuestra plataforma, valoramos su privacidad. Este documento detalla
          cómo recopilamos, usamos y protegemos su información personal. Al
          utilizar nuestros servicios, usted acepta las prácticas descritas en
          esta política.
        </p>
        <p class="mb-4">
          Recopilamos información como su nombre, correo electrónico y datos de
          navegación para mejorar su experiencia. Estos datos se almacenan de
          forma segura y no se compartirán con terceros sin su consentimiento
          explícito, salvo en casos requeridos por la ley.
        </p>
        <p class="mb-4">
          Usted tiene derecho a acceder, modificar o eliminar su información
          personal en cualquier momento. Si desea ejercer estos derechos,
          comuníquese con nuestro equipo de soporte.
        </p>
        <p class="mb-4">
          Esta política puede actualizarse periódicamente para reflejar cambios
          en nuestras prácticas o requisitos legales. Le recomendamos revisarla
          regularmente.
        </p>
      </div>

      <!-- Botón para aceptar política -->
      <button
        type="button"
        class="close-modal mt-6 py-3 px-6 text-base font-medium text_white template_color_customize rounded-lg hover:opacity-70 transition"
        (click)="closeModal()"
      >
        Aceptar
      </button>
    </div>
  </div>
</div>
